import React, { useEffect, useRef } from "react";
import moment from "moment";
import "./InventoryTables.css";
import {
  formatDot,
  switchDotsAndCommas,
  numberWithCommas,
} from "../../util/utilFunction";

const WEEKDAY = ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"];

const fmt = (n) => formatDot(switchDotsAndCommas(numberWithCommas(n)));

const TableKedatangan = ({ data, dates }) => {
  const items = Array.isArray(data) ? data : [];
  const days = Array.isArray(dates) ? dates : [];
  const scrollRef = useRef(null);

  // Tanggal hari ini (WIB), dibandingkan lengkap dengan bulan & tahun
  const todayStr = moment().utcOffset("+0700").format("YYYY-MM-DD");

  const dayMeta = days.map((d) => {
    const dow = moment(d.date).day();
    return {
      ...d,
      isToday: d.date === todayStr,
      isSunday: dow === 0,
      label: WEEKDAY[dow],
    };
  });

  // Geser otomatis ke kolom hari ini (kalau bulan yang dipilih memuat hari ini)
  useEffect(() => {
    const box = scrollRef.current;
    const today = box && box.querySelector(".tb-day-today");
    if (box && today) {
      const offset =
        today.getBoundingClientRect().left -
        box.getBoundingClientRect().left +
        box.scrollLeft -
        box.clientWidth / 2;
      box.scrollLeft = Math.max(0, offset);
    }
  }, [days.length, items.length, todayStr]);

  return (
    <div className="tb-card">
      <div className="tb-scroll tb-scroll-kd" ref={scrollRef}>
        <table className="tb-table tb-kd">
          <thead>
            <tr>
              <th className="tb-k1">No.</th>
              <th className="tb-k2">Cust</th>
              <th className="tb-k3">Item</th>
              <th className="tb-k4">Total</th>
              {dayMeta.map((d) => {
                let cls = "tb-day";
                if (d.isToday) cls += " tb-day-today";
                else if (d.isSunday) cls += " tb-day-sunday";
                return (
                  <th className={cls} key={d.date}>
                    <span className="tb-day-num">{d.tanggal}</span>
                    <span className="tb-day-name">{d.label}</span>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr className="tb-empty">
                <td colSpan={4 + dayMeta.length}>Tidak ada data kedatangan</td>
              </tr>
            ) : (
              items.map((item, index) => {
                const records = Array.isArray(item?.data) ? item.data : [];

                // Gabungkan data per tanggal: berat dijumlah, keterangan ambil yang pertama
                const byDate = new Map();
                records.forEach((r) => {
                  const cur = byDate.get(r.date);
                  if (cur) {
                    cur.dataWeight += r.dataWeight;
                  } else {
                    byDate.set(r.date, {
                      dataWeight: r.dataWeight,
                      keterangan: r.keterangan,
                    });
                  }
                });

                const total = records.reduce((s, r) => s + r.dataWeight, 0);

                return (
                  <tr key={`${item?.company}-${item?.material}-${index}`}>
                    <td className="tb-k1">{index + 1}.</td>
                    <td className="tb-k2">{item?.company}</td>
                    <td className="tb-k3" title={item?.material}>
                      {item?.material}
                    </td>
                    <td className="tb-k4">{fmt(total)}</td>

                    {dayMeta.map((d) => {
                      const cell = byDate.get(d.date);
                      const has = cell && cell.dataWeight;

                      let cls = "tb-cell";
                      if (has) cls += " tb-has-data";
                      else if (d.isToday) cls += " tb-col-today";
                      else if (d.isSunday) cls += " tb-col-sunday";

                      return (
                        <td className={cls} key={d.date}>
                          {has ? (
                            <>
                              <span className="tb-kd-qty">
                                {fmt(cell.dataWeight)}
                              </span>
                              {cell.keterangan ? (
                                <span
                                  className="tb-kd-note"
                                  title={cell.keterangan}
                                >
                                  {cell.keterangan}
                                </span>
                              ) : null}
                            </>
                          ) : null}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableKedatangan;
